import { validatePackageData } from './validator';
import { packageRequest, packageReceiveAction } from '../../actions/Section';
import { appErrorAction } from '../../actions/App';
import { callApiGet } from './common';
import { PACKAGE_ENDPOINT } from '../../constants/Api';
import { mergeRecursive } from '../common';
import env from '../../env.json';

// This is to simulate data coming from API.
import tryghedspakkenPackage from '../../assets/packages/package.tryghedspakken.json';
import tryghedspakkenPackageStatic from '../../assets/packages/package.tryghedspakken-static.json';
import carPackage from '../../assets/packages/car/package.car.json';
import carPackageText from '../../assets/packages/car/package.car-text.json';
import carPackageStatic from '../../assets/packages/car/package.car-static.json';
import carCarePackage from '../../assets/packages/carCare/package.carCare.json';
import carCarePackageText from '../../assets/packages/carCare/package.carCare-text.json';
import carCarePackageStatic from '../../assets/packages/carCare/package.carCare-static.json';
import carPackageFdm from '../../assets/packages/car/package.car-fdm.json';
import carPackageFdmText from '../../assets/packages/car/package.car-fdm-text.json';
import carPackageFdmStatic from '../../assets/packages/car/package.car-fdm-static.json';
import carPackageTjm from '../../assets/packages/car/package.car-tjm.json';
import retrieveOfferPackage from '../../assets/packages/retrieveOffer/package.retrieveOffer.json';
import retrieveOfferPackageText from '../../assets/packages/retrieveOffer/package.retrieveOffer-text.json';
import retrieveOfferPackageTjm from '../../assets/packages/retrieveOffer/package.retrieveOffer-tjm.json';
import retrieveOfferPackageStatic from '../../assets/packages/retrieveOffer/package.retrieveOffer-static.json';
import contentPackage from '../../assets/packages/content/package.content.json';
import contentPackageText from '../../assets/packages/content/package.content-text.json';
import contentPackageStatic from '../../assets/packages/content/package.content-static.json';
import personalPackage from '../../assets/packages/personal/package.personal.json';
import personalPackageText from '../../assets/packages/personal/package.personal-text.json';
import personalPackageStatic from '../../assets/packages/personal/package.personal-static.json';
import dogPackage from '../../assets/packages/dog/package.dog.json';
import dogPackageText from '../../assets/packages/dog/package.dog-text.json';
import dogPackageStatic from '../../assets/packages/dog/package.dog-static.json';
import dogPackageTjm from '../../assets/packages/dog/package.dog-tjm.json';
import catPackage from '../../assets/packages/cat/package.cat.json';
import catPackageText from '../../assets/packages/cat/package.cat-text.json';
import catPackageStatic from '../../assets/packages/cat/package.cat-static.json';
import catPackageTjm from '../../assets/packages/cat/package.cat-tjm.json';
import globalPackage from '../../assets/packages/package.global.json';
import globalPackageStatic from '../../assets/packages/package.global-static.json';
import insuranceCheckPackage from '../../assets/packages/insuranceCheck/package.insuranceCheck.json';
import insuranceCheckPackageAddress from '../../assets/packages/insuranceCheck/package.insuranceCheckAddressVariant.json';
import insuranceCheckPackageText from '../../assets/packages/insuranceCheck/package.insuranceCheck-text.json';
import insuranceCheckPackageStatic from '../../assets/packages/insuranceCheck/package.insuranceCheck-static.json';
import insuranceCheckPackageTjm from '../../assets/packages/insuranceCheck/package.insuranceCheck-tjm.json';
import trygPackage from '../../assets/packages/businessUnit/package.tryg-override-global.json';
import trygPackageText from '../../assets/packages/businessUnit/package.tryg-override-text.json';
import fdmPackage from '../../assets/packages/businessUnit/package.fdm-override-global.json';
import fdmPackageText from '../../assets/packages/businessUnit/package.fdm-override-text.json';
import mbbfPackage from '../../assets/packages/businessUnit/package.medlemsbutikken-bf-override-global.json';
import mbbfPackageText from '../../assets/packages/businessUnit/package.medlemsbutikken-bf-override-text.json';
import mbdjPackage from '../../assets/packages/businessUnit/package.medlemsbutikken-dj-override-global.json';
import mbdjPackageText from '../../assets/packages/businessUnit/package.medlemsbutikken-dj-override-text.json';
import mbfaodPackage from '../../assets/packages/businessUnit/package.medlemsbutikken-faod-override-global.json';
import mbfaodPackageText from '../../assets/packages/businessUnit/package.medlemsbutikken-faod-override-text.json';
import mbksPackage from '../../assets/packages/businessUnit/package.medlemsbutikken-ks-override-global.json';
import mbksPackageText from '../../assets/packages/businessUnit/package.medlemsbutikken-ks-override-text.json';
import fomoPackage from '../../assets/packages/businessUnit/package.fomo-override-global.json';
import fomoPackageText from '../../assets/packages/businessUnit/package.fomo-override-text.json';
import finaPackage from '../../assets/packages/businessUnit/package.finansforbundet-override-global.json';
import finaPackageText from '../../assets/packages/businessUnit/package.finansforbundet-override-text.json';
import laegePackage from '../../assets/packages/businessUnit/package.laegeforeningen-override-global.json';
import laegePackageText from '../../assets/packages/businessUnit/package.laegeforeningen-override-text.json';
import dbpcPackage from '../../assets/packages/businessUnit/package.danskebank-privatecustomer-override-global.json';
import dbpcPackageText from '../../assets/packages/businessUnit/package.danskebank-privatecustomer-override-text.json';
import tandPackage from '../../assets/packages/businessUnit/package.tandlaege-tryghed-override-global.json';
import tandPackageText from '../../assets/packages/businessUnit/package.tandlaege-tryghed-override-text.json';
import tjmPackage from '../../assets/packages/businessUnit/package.tjm-override-global.json';
import tjmPackageText from '../../assets/packages/businessUnit/package.tjm-override-text.json';
import tjmPackageStatic from '../../assets/packages/businessUnit/package.tjm-override-global-static.json';
import travelPackage from '../../assets/packages/travel/package.travel.json';
import travelPackageText from '../../assets/packages/travel/package.travel-text.json';
import travelPackageStatic from '../../assets/packages/travel/package.travel-static.json';
import travelPackageCU from '../../assets/packages/travel/cu/package.travel.json';
import travelPackageCUText from '../../assets/packages/travel/cu/package.travel-text.json';
import travelPackageTJMCU from '../../assets/packages/travel/cu/package.travel-tjm.json';
import travelPackageTJMCUText from '../../assets/packages/travel/cu/package.travel-tjm-text.json';
import travelPackageStaticCU from '../../assets/packages/travel/cu/package.travel-static.json';
import carPackageCU from '../../assets/packages/car/cu/package.car.json';
import carPackageCUText from '../../assets/packages/car/cu/package.car-text.json';
import carPackageStaticCU from '../../assets/packages/car/cu/package.car-static.json';
import carPackageFdmCU from '../../assets/packages/car/cu/package.car-fdm.json';
import carPackageFdmCUText from '../../assets/packages/car/cu/package.car-fdm-text.json';
import pefoSeniorPackageCU from '../../assets/packages/personal/cu/package.pefoSeniorCU.json';
import pefoSeniorPackageCUText from '../../assets/packages/personal/cu/package.pefoSeniorCU-text.json';
import pefoSeniorPackageStaticCU from '../../assets/packages/personal/cu/package.pefoSeniorCU-static.json';
import carPackageTjmCU from '../../assets/packages/car/cu/package.car-tjm.json';
import contentPackageCU from '../../assets/packages/content/cu/package.content.json';
import contentPackageCUText from '../../assets/packages/content/cu/package.content-text.json';
import contentPackageStaticCU from '../../assets/packages/content/cu/package.content-static.json';
import contentPackageTJMCU from '../../assets/packages/content/cu/package.content-tjm.json';
import contentPackageTJMCUText from '../../assets/packages/content/cu/package.content-tjm-text.json';
import contentPackageTJMStudentCU from '../../assets/packages/content/cu/package.content-tjm-student.json';
import contentPackageTJMStudentCUText from '../../assets/packages/content/cu/package.content-tjm-student-text.json';
import dogPackageCU from '../../assets/packages/dog/cu/package.dog.json';
import dogPackageCUText from '../../assets/packages/dog/cu/package.dog-text.json';
import dogPackageStaticCU from '../../assets/packages/dog/cu/package.dog-static.json';
import dogPackageTjmCU from '../../assets/packages/dog/cu/package.dog-tjm.json';
import dogPackageTjmCUText from '../../assets/packages/dog/cu/package.dog-tjm-text.json';
import catPackageCU from '../../assets/packages/cat/cu/package.cat.json';
import catPackageCUText from '../../assets/packages/cat/cu/package.cat-text.json';
import catPackageStaticCU from '../../assets/packages/cat/cu/package.cat-static.json';
import catPackageTjmCU from '../../assets/packages/cat/cu/package.cat-tjm.json';
import catPackageTjmCUText from '../../assets/packages/cat/cu/package.cat-tjm-text.json';
import example from '../../assets/packages/package.example.json';
import postalCodesPackage from '../../assets/packages/package.postalCodes.json';

/**
 * Determines if the state allows us to fetch data.
 * @param  {object} state The current state.
 * @return {boolean}      If we should fetch or not.
 */
const shouldFetch = (state) => {
  if (state.section) {
    const data = state.section.packageData;
    if (Object.keys(data).length === 0) {
      return true;
    }
    if (state.isFetching) {
      return false;
    }
  }

  return true;
};

/**
 * Mapping of package type/business unit to import of json package.
 * @type {Object}
 */
const packageData = {
  insuranceCheck: [
    insuranceCheckPackage,
    postalCodesPackage,
    insuranceCheckPackageText,
    insuranceCheckPackageStatic,
  ],
  car: [carPackage, carPackageText, carPackageStatic],
  carCare: [carCarePackage, carCarePackageText, carCarePackageStatic],
  carCU: [carPackageCU, carPackageCUText, carPackageStaticCU],
  content: [contentPackage, contentPackageText, contentPackageStatic],
  contentCU: [contentPackageCU, contentPackageCUText, contentPackageStaticCU],
  contentStudentCU: [contentPackageCU, contentPackageCUText, contentPackageStaticCU],
  personal: [personalPackage, personalPackageText, personalPackageStatic],
  dog: [dogPackage, dogPackageText, dogPackageStatic],
  dogCU: [dogPackageCU, dogPackageCUText, dogPackageStaticCU],
  cat: [catPackage, catPackageText, catPackageStatic],
  catCU: [catPackageCU, catPackageCUText, catPackageStaticCU],
  pefoSeniorCU: [pefoSeniorPackageCU, pefoSeniorPackageCUText, pefoSeniorPackageStaticCU],
  travel: [travelPackage, travelPackageText, travelPackageStatic],
  travelCU: [travelPackageCU, travelPackageCUText, travelPackageStaticCU],
  tryghedspakken: [tryghedspakkenPackage, tryghedspakkenPackageStatic],
  retrieveOffer: [retrieveOfferPackage, retrieveOfferPackageText, retrieveOfferPackageStatic],
  fdm: {
    car: [carPackageFdm, carPackageFdmText, carPackageFdmStatic],
    carCU: [carPackageFdmCU, carPackageFdmCUText],
  },
  tjm: {
    car: [carPackageTjm],
    carCU: [carPackageTjmCU],
    cat: [catPackageTjm],
    catCU: [catPackageTjmCU, catPackageTjmCUText],
    contentCU: [contentPackageTJMCU, contentPackageTJMCUText],
    contentStudentCU: [contentPackageTJMStudentCU, contentPackageTJMStudentCUText,
      contentPackageStaticCU],
    dog: [dogPackageTjm],
    dogCU: [dogPackageTjmCU, dogPackageTjmCUText],
    travelCU: [travelPackageTJMCU, travelPackageTJMCUText],
    retrieveOffer: [retrieveOfferPackageTjm],
    insuranceCheck: [insuranceCheckPackageTjm],
  },
  businessUnit: {
    tryg: [trygPackage, trygPackageText],
    fdm: [fdmPackage, fdmPackageText],
    fina: [finaPackage, finaPackageText],
    tand: [tandPackage, tandPackageText],
    mbbf: [mbbfPackage, mbbfPackageText],
    mbdj: [mbdjPackage, mbdjPackageText],
    mbfaod: [mbfaodPackage, mbfaodPackageText],
    mbks: [mbksPackage, mbksPackageText],
    fomo: [fomoPackage, fomoPackageText],
    dbpc: [dbpcPackage, dbpcPackageText],
    laege: [laegePackage, laegePackageText],
    tjm: [tjmPackage, tjmPackageText, tjmPackageStatic],
  },
  example: [example],
  variant: {
    insuranceCheckAddress: [insuranceCheckPackageAddress],
  },
};

/**
 * Get merge package including static, business and global.
 * @return {Object}
 */
export const getPackage = () => {
  let pack = mergeRecursive(globalPackage, globalPackageStatic);
  // Business Unit specific flow override of global.
  if (packageData.businessUnit[env.businessUnit]) {
    pack = mergeRecursive(pack, packageData.businessUnit[env.businessUnit][0]);
    if (packageData.businessUnit[env.businessUnit].length > 2) {
      pack = mergeRecursive(pack, packageData.businessUnit[env.businessUnit][2]);
    }
  }
  // The product specific flows of the package.
  pack = mergeRecursive(pack, packageData[env.package][0]);
  if (packageData[env.package][1]) {
    pack = mergeRecursive(pack, packageData[env.package][1]);
  }
  if (packageData[env.package][2]) {
    pack = mergeRecursive(pack, packageData[env.package][2]);
  }
  if (env.variant && packageData.variant) {
    if (packageData.variant[env.variant][0]) {
      pack = mergeRecursive(pack, packageData.variant[env.variant][0]);
    }
    if (packageData.variant[env.variant][1]) {
      pack = mergeRecursive(pack, packageData.variant[env.variant][1]);
    }
  }
  // Business Unit text override of all flows.
  if (packageData.businessUnit[env.businessUnit].length > 1) {
    pack = mergeRecursive(pack, packageData.businessUnit[env.businessUnit][1]);
  }
  // Business Unit specific flow override of package.
  const businessUnit = packageData[env.businessUnit];
  if (businessUnit) {
    if (businessUnit[env.package]) {
      pack = mergeRecursive(pack, businessUnit[env.package][0]);
      if (businessUnit[env.package][1]) {
        pack = mergeRecursive(pack, businessUnit[env.package][1]);
      }
      if (businessUnit[env.package][2]) {
        pack = mergeRecursive(pack, businessUnit[env.package][2]);
      }
    }
  }
  return pack;
};

/**
 * Fetches the hardcoded json file.
 * @return {Promise} A Promise that will resolve/reject after 1500ms.
 */
const fetchHardcodedPromise = () => {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      const pack = getPackage();
      const validatorResult = validatePackageData(pack);
      if (validatorResult.errors.length === 0) {
        resolve(pack);
      } else {
        // Throw validation error.
        const errorData = {
          errorType: 'validationError',
          errorData: validatorResult.errors,
        };
        reject(errorData);
      }
    }, 1500);
  });
};

/**
 * Fetches package data and validates it.
 * @return {function} Dispatch function.
 */
const fetchPackageData = (state = { app: {} }) => {
  return dispatch => {
    dispatch(packageRequest());
    // If we are on dev we use the hardcoded json.
    if (process.env.NODE_ENV !== 'production') {
      return fetchHardcodedPromise()
        .then(data => dispatch(packageReceiveAction(data)))
        .catch(data => dispatch(appErrorAction(data)));
    }

    // Call service for fetching the package.
    const params = {
      path: state.app.pathname || window.location.pathname,
    };
    return callApiGet(PACKAGE_ENDPOINT, params, dispatch, false, false)
      .then(data => dispatch(packageReceiveAction(data)))
      .catch(data => dispatch(appErrorAction(data)));
  };
};

/**
 * Fetches a package from API.
 * @return {object} The Promise to fetch data.
 */
export const getPackageData = () => {
  return (dispatch, getState) => {
    const state = getState();
    if (shouldFetch(state)) {
      // Dispatch a thunk from thunk!
      return dispatch(fetchPackageData(state));
    }
    // Let the calling code know there's nothing to wait for.
    return Promise.resolve();
  };
};



// WEBPACK FOOTER //
// ./src/utilities/api/package.js